/** Light and dark, driven entirely by CSS custom properties. The only thing JavaScript does is
 * set a `data-theme` attribute on <html>; every colour lives in the stylesheet, because
 * `style="..."` attributes are silently refused under `style-src 'self'`. */
const STORAGE_KEY = "door-theme";

export type Theme = "light" | "dark" | "system";

export function readTheme(): Theme {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "light" || stored === "dark" || stored === "system") return stored;
  } catch {
    // Private windows and blocked site data both throw here. A missing preference is not an
    // error - fall back to following the operating system.
  }
  return "system";
}

export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  if (theme === "system") {
    root.removeAttribute("data-theme");
  } else {
    root.setAttribute("data-theme", theme);
  }
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // The theme still applies for this page; it just will not be remembered.
  }
}

export function nextTheme(current: Theme): Theme {
  return current === "system" ? "light" : current === "light" ? "dark" : "system";
}
